module.exports = __webpack_public_path__ + "static/img/1-3.1b7824b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/1-3.png
// module id = Pysm
// module chunks = 1